/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import Timeout from "await-timeout";
import { useFormik } from "formik";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useAuth } from "../../context/AuthContext";
import { handleErrors } from "../../services/handleErrors";
import { SpinnerButtonPrimary } from "../../ui/buttons";
import { CheckboxLogin } from "../../ui/inputs";
import { PasswordInput } from "../PasswordInput";
import MfaConfig from "./mfaConfig";
import { ButtonRecovery, Input, InputContainer, Label, LinkContainer, OtpWrapper, SubLabel, SubTitle, Title } from "./styles";

const FormLogin = ({ onLogin, handlePersuacion }) => {
  const { login } = useAuth();
  const [twofaForm, setTwofaForm] = useState(false);
  const [recoverAccount, setRecoverAccount] = useState(false);
  const [recordarDispositivo, setRecordarDispositivo] = useState(false);
  const [incorrectToken, setIncorrectToken] = useState(false);
  const browserHash = JSON.parse(localStorage.getItem("browserHash")) || null;
  const [openConfigModals, setOpenConfigModals] = useState(false);
  const [userInfo, setUserInfo] = useState();

  const handleCheck = () => {
    setRecordarDispositivo(!recordarDispositivo);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      twofa: "",
      browserHash: "",
      backupCode: "",
    },
    onSubmit: async (values) => {
      if (browserHash) {
        values.browserHash = browserHash;
      }

      try {
        let message;
        if (values.backupCode) {
          message = await login(values.email, values.password, values.twofa, recordarDispositivo, values.browserHash, values.backupCode);
          setRecoverAccount(false);
          setTwofaForm(false);
          localStorage.removeItem("browserHash");
          values.backupCode = "";
        } else if (values.browserHash) {
          message = await login(values.email, values.password, values.twofa, recordarDispositivo, values.browserHash);
        } else if (values.twofa) {
          message = await login(values.email, values.password, values.twofa, recordarDispositivo);
        } else {
          message = await login(values.email, values.password);
        }

        // si no tiene mfa activo abre los modales de configuracion.
        if (message === 403) {
          setOpenConfigModals(true);
          setUserInfo(values);
        } else if (message === 428) {
          setTwofaForm(true);
        } else if (message === 423) {
          setTwofaForm(false);
        } else if (message >= 400) {
          // eslint-disable-next-line no-throw-literal
          throw { httpCode: message };
        } else {
          toast.success(message);
          await Timeout.set(1000);
          // activa el modal de persuacion si no se usa mfa
          if (values.twofa || values.browserHash) {
            onLogin();
          } else {
            handlePersuacion();
          }
        }
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
        setIncorrectToken(true);
      }
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Este campo es requerido.").email("Este campo debe ser un mail válido"),
      password: Yup.string()
        .required("Este campo es requerido.")
        .test("len", "Este campo debe contener al menos 5 catacteres", (val) => val && val.length >= 5),
      twofa: Yup.string().test("twofa-required", "Ingrese un código.", function (value) {
        return recoverAccount ? true : twofaForm ? !!value : true;
      }),
      backupCode: Yup.string().test("backupCode-required", "Ingrese un código.", function (value) {
        return recoverAccount ? !!value : true;
      }),
    }),
  });

  const tokenError = () => {
    let error = "";
    if (incorrectToken) {
      error = "El código no coincide";
    }
    return error;
  };
  const messageError = tokenError();

  return (
    <>
      {openConfigModals && <MfaConfig setOpenConfigModals={setOpenConfigModals} userInfo={userInfo || null} />}
      {twofaForm ? (
        <div className="text-center d-flex justify-content-center align-items-center mb-3" style={{ width: "fit-content", margin: "0 auto" }}>
          {recoverAccount ? <Title>Recuperar cuenta</Title> : <Title>Autenticación</Title>}
        </div>
      ) : (
        <div>
          <Title>Iniciar sesión</Title>
          <SubTitle>Ingrese usuario y contraseña</SubTitle>
        </div>
      )}

      <form className="mt-3" onSubmit={formik.handleSubmit}>
        {twofaForm ? (
          recoverAccount ? (
            <>
              <InputContainer>
                <SubLabel className="pt-0">Por favor, introduzca el código de respaldo proporcionado al activar su A2FA.</SubLabel>
                <Input
                  className={(formik.errors.backupCode || messageError) && formik.touched.backupCode ? "form-control error-field" : "form-control"}
                  type="backupCode"
                  name="backupCode"
                  placeholder="Ingrese su codigo de respaldo"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.backupCode}
                />
                {(messageError || formik.errors.backupCode) && formik.touched.backupCode && (
                  <div className="input-feedback" style={{ height: "8px" }}>
                    {formik.errors.backupCode || messageError}
                  </div>
                )}
              </InputContainer>
            </>
          ) : (
            <>
              <div className="d-flex justify-content-center flex-column">
                <Label className="text-center pt-0">Ingrese el código de autenticación</Label>
                <OtpWrapper>
                  <OtpInput
                    name="twofa"
                    type="twofa"
                    value={formik.values.twofa}
                    onChange={(value) => formik.setFieldValue("twofa", value)}
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                  />
                  {(messageError || formik.errors.twofa) && formik.touched.twofa && (
                    <div className="input-feedback" style={{ height: "8px" }}>
                      {formik.errors.twofa || messageError}
                    </div>
                  )}
                </OtpWrapper>
              </div>
              <div className="d-flex mb-2" style={{ width: "fit-content", margin: "0 auto", alignItems: "center" }}>
                <SubLabel className="col-form-label p-0 mx-2">Recordar este navegador por 30 días</SubLabel>
                <CheckboxLogin id="twofa" name="twofa" onChange={handleCheck} value="false" />
              </div>
            </>
          )
        ) : (
          <>
            <InputContainer>
              <Label>Usuario</Label>
              <Input
                className={formik.errors.email && formik.touched.email ? "form-control error-field" : "form-control"}
                style={formik.errors.email && formik.touched.email ? { border: "1px solid red" } : null}
                type="email"
                name="email"
                placeholder="Ingrese su email"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.errors.email && formik.touched.email && (
                <div className="input-feedback" style={{ height: "8px" }}>
                  {formik.errors.email}
                </div>
              )}
            </InputContainer>
            <InputContainer>
              <Label>Contraseña</Label>
              <PasswordInput
                className={formik.errors.password && formik.touched.password ? "error-field" : ""}
                style={formik.errors.password && formik.touched.password ? { border: "1px solid red", borderRadius: "5px" } : { borderRadius: "5px" }}
                name="password"
                placeholder="Ingrese su contraseña"
                disabled={formik.isSubmitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {formik.errors.password && formik.touched.password && (
                <div className="input-feedback" style={{ height: "8px" }}>
                  {formik.errors.password}
                </div>
              )}
            </InputContainer>
          </>
        )}

        <div className=" mt-3 mb-0">
          <SpinnerButtonPrimary
            marginRight="0px"
            className="btn-block"
            maxHeight="40px"
            padding="20px"
            justifyContent="center"
            isLoading={formik.isSubmitting}
            disabled={formik.isSubmitting}
            type="submit"
          >
            {recoverAccount ? "Recuperar cuenta" : "Iniciar sesión"}
          </SpinnerButtonPrimary>
          {recoverAccount ? (
            <ButtonRecovery className="text-center mt-3" type="button" onClick={() => setRecoverAccount(false)}>
              Volver
            </ButtonRecovery>
          ) : (
            ""
          )}
        </div>
        {formik.errors.loginerror && (
          <div className="input-feedback" style={{ height: "8px" }}>
            {formik.errors.loginerror}
          </div>
        )}
        {twofaForm ? (
          recoverAccount ? (
            ""
          ) : (
            <ButtonRecovery
              type="button"
              className="text-center"
              onClick={() => {
                setRecoverAccount(true);
                setIncorrectToken(false);
              }}
            >
              Recuperar Cuenta
            </ButtonRecovery>
          )
        ) : (
          <LinkContainer>
            <Link to="/forgot">Olvide mi contraseña</Link>
          </LinkContainer>
        )}
      </form>
    </>
  );
};

export default FormLogin;
